"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M17.054 37.145c-3.1 1.116-6.975 2.516-9.652 3.475l3.456-9.653zm16.64-32.727L8.82 29.292a2.231 2.231 0 0 0-.521.814L4.115 41.659a1.654 1.654 0 0 0 2.171 2.186L17.9 39.713a2.23 2.23 0 0 0 .826-.526L43.59 14.274a1.887 1.887 0 0 0 .172-2.653l-7.42-7.382a1.888 1.888 0 0 0-2.648.179z" })
);

